// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  padding: var(--spacing-small-plus) var(--spacing-large) var(--spacing-small);
}

mat-dialog-content {
  min-height: 85px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

mat-dialog-actions {
  gap: var(--spacing-medium);
}

button {
  padding: 0 var(--spacing-medium);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/health-center/sensor-order-shipping-dialog/sensor-order-shipping-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,4EAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,gCAAA;AACF","sourcesContent":["h2 {\n  padding: var(--spacing-small-plus) var(--spacing-large) var(--spacing-small);\n}\n\nmat-dialog-content {\n  min-height: 85px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\nmat-dialog-actions {\n  gap: var(--spacing-medium);\n}\n\nbutton {\n  padding: 0 var(--spacing-medium);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
